/* Mystic Modesty — Lookbook scroll-fade animation
   Adds .mm-lb-visible to elements with [data-mm-lb-fade] when they enter viewport.
*/
(function () {
  'use strict';

  function init() {
    var nodes = document.querySelectorAll('[data-mm-lb-fade]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything immediately
      Array.prototype.forEach.call(nodes, function (n) {
        n.classList.add('mm-lb-visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mm-lb-visible');
          io.unobserve(e.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1
    });

    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });

    // Hero: trigger immediately
    var hero = document.querySelector('.mm-lb-hero');
    if (hero) {
      requestAnimationFrame(function () {
        hero.classList.add('mm-lb-visible');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-mm-lookbook]')) init();
  });
})();
